import { Authenticator, ThemeProvider } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Backdrop, CircularProgress, Grid, List, ListItem, Stack, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { Amplify, Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import LoginBackground from "../../assets/login-bg.png";
import Loginimg from "../../assets/login-img-2.png";
import Logo from "../../assets/logo-blue.png";
import { signIn, signOut as signOutRedux } from "../../redux/auth/authSlice";
import { getApplicationAsync, resetUser } from "../../redux/user/userSlice";
import { config } from "../../utils/config";
import { API, getNirvToken, getScreeningId, getStudentEmail, setCredentialTypeCode, setNirvToken, setScreeningId, setStudentEmail } from "../../utils/http";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
Amplify.configure(config.awsConfig);
function PrivateRoutes() {
	const [searchParams] = useSearchParams();
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		const token = searchParams.get("nirv-token");
		const credentialTypeCode = searchParams.get("credentialTypeCode");
		const screeningId = searchParams.get("screeningId");
		if (token) {
			setLoading(true);
			console.log("Token: ", token);
			//call api and then
			// setNirvToken(token);
			API.get(`token/${token}?credentialTypeCode=${credentialTypeCode}`)
				.then((r) => {
					const res = r.data.payload;
					console.log(res);
					console.log(res.student);
					if (res.student?.email) {
						Auth.signIn(res.userName, res.password).then((r) => {
							console.log(r);
							// window.location.reload();
							setNirvToken(token);
							setCredentialTypeCode(credentialTypeCode);
							setStudentEmail(res.student.email);
							toast.success("You have been logged in successfully");
							window.location.href = window.location.origin + "/dashboard";
						});
					} else {
						toast.error("Invalid token");
						// window.location.href = window.location.origin + "/dashboard";
					}
					setLoading(false);
				})
				.catch((e) => {
					console.log(e);
					toast.error("Failed to sign in with NIRV token", {
						autoClose: false,
					});
					setLoading(false);
				});
		}

		// Handle screening ID similar to NIRV token
		if (screeningId) {
			setLoading(true);
			console.log("Screening ID: ", screeningId);
			// Call API to get student info and then sign in
			console.log("Retrieving screening information");

			API.get(`screenings-proxy/${screeningId}`)
				.then((r) => {
					const res = r.data.payload;
					if (res.redirect) {
						window.location.href = res.targetUrl;
					}
					console.log("Screening information: ", res);
					console.log(r.data);
					console.log(res);
					if (res.email && res.proxyAccount?.userName && res.proxyAccount?.password) {
						Auth.signIn(res.proxyAccount.userName, res.proxyAccount.password)
							.then((r) => {
								console.log(r);
								setScreeningId(screeningId);
								setStudentEmail(res.email);
								toast.success("You have been logged in successfully");
								window.location.href = window.location.origin + "/dashboard";
							})
							.catch((e) => {
								toast.error("Failed to sign in");
							});
					} else {
						toast.error("Invalid screening ID");
					}
				})
				.catch((e) => {
					console.log(e);
					toast.error("Failed to retrieve screening information", {
						autoClose: false,
					});
					setLoading(false);
				});
		}
	}, []);

	const screeningId = searchParams.get("screeningId");

	const theme = {
		name: "Auth Example Theme",
		tokens: {
			colors: {
				font: {
					interactive: {
						value: "#0054A6",
					},
				},
				brand: {
					primary: {
						10: "#66b5ff",
						80: "#0054A6",
						90: "#0061bc",
						100: "#0061bc",
					},
				},
			},
			components: {
				tabs: {
					item: {
						_focus: {
							color: {
								value: "#0054A6",
							},
						},
						_hover: {
							color: {
								value: "#0054A6",
							},
						},
						_active: {
							color: {
								value: "#0054A6",
							},
						},
					},
				},
			},
		},
	};

	const components = {
		SignUp: {
			Footer() {
				return (
					<Stack paddingX={4} paddingBottom={4}>
						<Typography>Password requirements:</Typography>
						<List dense={true}>
							<ListItem>~ Contains at least 1 number</ListItem>
							<ListItem>~ Contains at least 1 special character</ListItem>
							<ListItem>~ Contains at least 1 uppercase letter</ListItem>
							<ListItem>~ Contains at least 1 lowercase letter</ListItem>
						</List>
					</Stack>
				);
			},
		},
	};
	const dispatch = useDispatch();

	return (
		<Grid
			container
			alignItems="center"
			sx={{ minHeight: { xs: "100vh" }, backgroundimg: `url(${LoginBackground})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
		>
			<Grid item sm={6} xs={12} sx={{ display: { xs: "none", sm: "initial" } }}>
				<img src={Loginimg} width="100%" alt="logo" />
			</Grid>
			<Grid item sm={6} xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={12} textAlign={"center"}>
						<img src={Logo} height="200px" alt="logo" />
					</Grid>
					<Grid item xs={12}>
						<ThemeProvider theme={theme}>
							{loading ? (
								<Backdrop open={loading} onClick={() => {}} sx={{ zIndex: 1000 }}>
									<CircularProgress color="inherit" />
								</Backdrop>
							) : (
								<Authenticator
									loginMechanisms={["email"]}
									components={components}
									initialState={screeningId ? "signUp" : "signIn"}
									formFields={{
										signUp: {
											email: {
												placeholder: "Enter your email address",
											},
										},
									}}
								>
									{({ signOut, user }) => {
										return (
											<Content
												signOut={() => {
													signOut();
													dispatch(signOutRedux());
													dispatch(resetUser());
												}}
												user={user}
											/>
										);
									}}
								</Authenticator>
							)}
						</ThemeProvider>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

function Content({ signOut, user }) {
	const currentEmail = user.attributes.email;
	useEffect(() => {
		console.log(user);
		const studentEmail = getStudentEmail();
		const nirvToken = getNirvToken();
		const screeningId = getScreeningId();
		console.log("Student email: ", studentEmail);
		console.log("Current email: ", currentEmail);
		console.log("Screening ID: ", screeningId);
		if (currentEmail === "nirvsystem@gutenbergcerts.com" && !studentEmail) {
			signOut();
			console.error("You are not authorized to access this page");
			return;
		}
		if (currentEmail === "verified@policecerts.com" && !studentEmail) {
			//TODO: update the actual email
			signOut();
			console.error("You are not authorized to access this page");
			return;
		}
		const r = {
			nirvToken: nirvToken,
			screeningId: screeningId,
			email: studentEmail ?? user.attributes.email,
			idToken: user.signInUserSession.idToken.jwtToken,
			authorization: user.signInUserSession.accessToken.jwtToken,
		};
		dispatch(signIn(r));
		dispatch(getApplicationAsync())
			.unwrap()
			.then((r) => {
				console.log(r);
			})
			.catch((e) => {
				console.log(e);
				toast.error("Failed to get application", {
					autoClose: false,
				});
			});
	}, [user]);
	const dispatch = useDispatch();
	const style = user
		? { position: "absolute", top: 0, left: 0, width: "100%", backgroundColor: "white", minHeight: "100vh", display: "flex", flexDirection: "column" }
		: {};
	return (
		<div style={style}>
			<Navbar signOut={signOut} />

			<Container maxWidth="lg" sx={{ flexGrow: 1 }}>
				<Outlet />
			</Container>
			<Footer />
		</div>
	);
}

export default PrivateRoutes;
